import { normalizeAuthUser } from "./authSession";

const IMPERSONATION_ORIGINAL_KEY = "solarent_impersonation_original";

/** Where support admins land after leaving impersonation. */
export const IMPERSONATION_RETURN_PATH = "/UM/Yeksa/userinfo";

export function saveImpersonationOriginal(user) {
  const normalized = normalizeAuthUser(user);
  if (!normalized) {
    return false;
  }

  try {
    sessionStorage.setItem(IMPERSONATION_ORIGINAL_KEY, JSON.stringify(normalized));
    return true;
  } catch {
    return false;
  }
}

export function readImpersonationOriginal() {
  try {
    const raw = sessionStorage.getItem(IMPERSONATION_ORIGINAL_KEY);
    if (!raw) {
      return null;
    }
    return normalizeAuthUser(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function clearImpersonationOriginal() {
  try {
    sessionStorage.removeItem(IMPERSONATION_ORIGINAL_KEY);
  } catch {
    // ignore
  }
}

export function isImpersonating() {
  return Boolean(readImpersonationOriginal());
}
